import React, {
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import {
  FontAwesomeIcon,
} from "@fortawesome/react-fontawesome";

import {
  faArrowRight,
  faBell,
} from "@fortawesome/free-solid-svg-icons";

import toast from "react-hot-toast";

import NotificationCampaignForm from "../components/notifications/NotificationCampaignForm";

import {
  notificationCampaignsApi,
} from "../api/notificationCampaignsApi";

import type {
  CreateNotificationCampaignInput,
} from "../types/notification-campaigns.types";

import "../screenstyles/NotificationCampaignForm.css";

const AddNotificationCampaign:
React.FC = () => {
  const navigate =
    useNavigate();

  const [
    saving,
    setSaving,
  ] =
    useState(false);

  const handleSubmit =
    async (
      input:
        CreateNotificationCampaignInput,
    ) => {
      try {
        setSaving(
          true,
        );

        const result =
          await notificationCampaignsApi
            .create(
              input,
            );

        toast.success(
          "تم إنشاء حملة الإشعارات بنجاح",
        );

        navigate(
          `/notification-campaigns/${result.campaign.campaignId}`,
        );
      } catch (
        error: any
      ) {
        console.error(
          "Failed to create campaign:",
          error,
        );

        toast.error(
          error?.message ||
            "فشل إنشاء الحملة",
        );
      } finally {
        setSaving(
          false,
        );
      }
    };

  return (
    <div className="notification-campaign-form-page">
      <header className="notification-campaign-form-header">
        <div>
          <span>
            <FontAwesomeIcon
              icon={faBell}
            />

            إدارة الإشعارات
          </span>

          <h1>
            إنشاء حملة جديدة
          </h1>

          <p>
            أنشئ إشعارًا وحدد
            الجمهور وموعد الإرسال
            من مكان واحد.
          </p>
        </div>

        <button
          type="button"
          onClick={() =>
            navigate(
              "/notification-campaigns",
            )
          }
        >
          <FontAwesomeIcon
            icon={
              faArrowRight
            }
          />

          رجوع
        </button>
      </header>

      <NotificationCampaignForm
        loading={
          saving
        }
        submitLabel="إنشاء الحملة"
        onSubmit={
          handleSubmit
        }
      />
    </div>
  );
};

export default AddNotificationCampaign;